<template>
    <PopupContainer>
        <template #header><div class="header"><span class="title">选择登录账号</span></div></template>
        
        <div style="width: 460px;display: flex; flex-direction: column; justify-content: center; align-items: center">
            <div v-for="tenant of tenantList"
                style="cursor: pointer; width: 100%;margin-bottom: 16px;padding: 8px;border-radius: 3px" 
                :style="{
                    border: selectedTenantId == tenant.tenantId? '1px solid #327DE8':'1px solid #D3D4D6'
                }" 
                @click.prevent="selectedTenantId = tenant.tenantId">
                <div style="pointer-events: none">
                    <div style="font-weight: 700">卖家账号：{{ tenant.tenantId }}</div>
                    <div style="margin-top: 8px">公司名称：{{ tenant.name }}</div>
                </div>
            </div>
            <el-button type="primary" @click="popup.done(selectedTenantId)">确认</el-button>
        </div>
    </PopupContainer>
</template>
<script lang="ts" setup>
import { PopupContainer, PopupCtx, usePopup } from '@/components/easy';

const props = defineProps<{
    tenantList: { 
        tenantId: string,
        name: string
    }[],

    popupCtx?: PopupCtx<string>;
}>()

const selectedTenantId = ref(props.tenantList[0].tenantId);

const popup = usePopup(props);

</script>
<style lang="scss" scoped>
.header {
    text-align: center;
}

.title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
}

</style>